export default __webpack_public_path__ + "static/media/rounded-bottom.0244822d.webp";